import React from "react";
import { ClickOutside } from "./../../ui-components/index.js";
import { AUDIO_CONTEXT_COMMON_MENU, AUDIO_PLAYBACK_SPEED_MENU } from "../data-hooks.js";
import DropdownMenu from "./DropdownMenu.js";
const ContextMenu = ({
  onClickOutside,
  contextMenuData,
  playBackMenuData,
  showContextMenu,
  showPlaybackMenu
}) => {
  return /* @__PURE__ */ React.createElement(ClickOutside, { onClickOutside }, showContextMenu && /* @__PURE__ */ React.createElement(
    DropdownMenu,
    {
      dataHook: AUDIO_CONTEXT_COMMON_MENU,
      options: contextMenuData,
      onClose: onClickOutside
    }
  ), showPlaybackMenu && /* @__PURE__ */ React.createElement(
    DropdownMenu,
    {
      dataHook: AUDIO_PLAYBACK_SPEED_MENU,
      options: playBackMenuData,
      onClose: onClickOutside
    }
  ));
};
var ContextMenu_default = ContextMenu;
export {
  ContextMenu_default as default
};
//# sourceMappingURL=ContextMenu.js.map
